import { bundleConfig } from '../../../../config';
import { BundleResponseOut } from '../../../../store/api';
import { http } from '../../../../api/axios';

export interface BundleParams {
    loanFormat?: string | null;
    pagination: {
        readonly page: number;
        readonly pageSize: number;
        readonly sortBy: string;
    };
    ageCategory?: string | null;
    queryParams: {
        releaseYear?: string;
        categories?: string;
    };
}

export const fetchLanguageLearningBundles = ({ loanFormat, pagination, ageCategory, queryParams }: BundleParams) => {
    const endpoint = bundleConfig().endpointForeignLanguageBundles;

    const pathParams = {
        loanFormat: loanFormat === 'all' ? null : loanFormat,
        kind: ''
    };

    const params = {
        ...pagination,
        ageCategory: ageCategory === 'All+Ages' ? null : ageCategory,
        includeProducts: true
    };

    if (queryParams.releaseYear) {
        params['category'] = `releaseYear#${queryParams.releaseYear}`;
    } else if (queryParams.categories) {
        params['category'] = `categories#${queryParams.categories}`;
    }

    return http.get<BundleResponseOut>(endpoint, { params, pathParams }).then(response => response.data);
};
